import { ImageInfo, NBCItem, NBCProfile } from '../../Interfaces/NBC/NBCItem';
import { Action, Reducer } from 'redux';
import { AppThunkAction } from '..';
import { getRequestOptions, postRequestOptions } from '../../utils/utils';
import { FetchError } from '../../Interfaces/FetchError';
import { ResultResponse } from '../../Interfaces/ResultResponse';
import {
  DrilldownProfile,
  TreeViewDataItem,
} from '../../Interfaces/NBC/Drilldown';
import _ from 'lodash';
import { NBC_DRILLDOWN, NBC_ITEM } from '../../utils/constants';
import { NBCItemGroups } from '../../Interfaces/NBC/NBCItemGroups';

export enum NBCActionTypes {
  RECEIVED_ALL_NBC_ITEMS = 'RECEIVED_ALL_NBC_ITEMS',
  NBC_UNAUTHORIZED_REQUEST = 'NBC_UNAUTHORIZED_REQUEST',
  RESET_NBC_HTTP_RESPONSE_FETCH_ERROR = 'RESET_NBC_HTTP_RESPONSE_FETCH_ERROR',
  RECEIVED_NBC_HTTP_RESPONSE_ERROR_CODE = 'RECEIVED_NBC_HTTP_RESPONSE_ERROR_CODE',
  ADD_NEW_NBC_ITEM = 'ADD_NEW_NBC_ITEM',
  REQUEST_ALL_NBC_ITEMS = 'REQUEST_ALL_NBC_ITEMS',
  UPDATE_NBC_ITEMS = 'UPDATE_NBC_ITEMS',
  REQUEST_SAVE_NBC_ITEMS = 'REQUEST_SAVE_NBC_ITEMS',
  RECEIVED_PROFILE_NAME_LIST = 'RECEIVED_PROFILE_NAME_LIST',
  ADD_NEW_NBC_PROFILE = 'ADD_NEW_NBC_PROFILE',
  EDIT_NBC_PROFILE = 'EDIT_NBC_PROFILE',
  DELETE_NBC_PROFILE = 'DELETE_NBC_PROFILE',
  OVERWRITE_NBC_ITEMS = 'OVERWRITE_NBC_ITEMS',
  IMPORT_IMAGES = 'IMPORT_IMAGES',
  GET_ALL_NBC_IMAGES = 'GET_ALL_NBC_IMAGES',
  RESET_NOTIFICATION_MESSAGE = 'RESET_NOTIFICATION_MESSAGE',
  APPLY_SNAPSHOT = 'APPLY_SNAPSHOT',
  DELETE_NBC_ITEMS = 'DELETE_NBC_ITEMS',
  ADD_NEW_DRILLDOWN = 'ADD_NEW_DRILLDOWN',
  ADD_ITEM_TO_DRILLDOWN = 'ADD_ITEM_TO_DRILLDOWN',
  GET_DRILLDOWN_PROFILE_BY_ID = 'GET_DRILLDOWN_PROFILE_BY_ID',
  REQUEST_DRILLDOWN_PROFILE = 'REQUEST_DRILLDOWN_PROFILE',
  REQUEST_DELETE_DRILLDOWN = 'REQUEST_DELETE_DRILLDOWN',
  REQUEST_DELETE_DRILLDOWN_ITEM = 'REQUEST_DELETE_DRILLDOWN_ITEM',
  REQUEST_DRILLDOWN_ITEMS = 'REQUEST_DRILLDOWN_ITEMS',
  FETCHING_DRILLDOWNS = 'FETCHING_DRILLDOWNS',
  LOADING_ITEMS_GROUPS = 'LOADING_ITEMS_GROUPS',
  GET_ITEMS_GROUPS = 'GET_ITEMS_GROUPS',
  SET_NOTIFICATION_MESSAGE = 'SET_NOTIFICATION_MESSAGE',
  UPDATE_DRILLDOWN = 'UPDATE_DRILLDOWN',
  REQUEST_UPDATE_DRILLDOWN = 'REQUEST_UPDATE_DRILLDOWN',
  UPDATE_DRILLDOWN_POSITION = 'UPDATE_DRILLDOWN_POSITION',
}

export interface NBCState {
  nbcItems: NBCItem[];
  fetchingNbcItems: boolean;
  updateNBCItem: NBCItem[];
  profileNames: NBCProfile[];
  fetchError: FetchError;
  nbcImages: string[];
  messageNotification: string;
  response: ResultResponse;
  drilldownProfile: DrilldownProfile;
  drilldownItems: string[] | null;
  fetchingDrilldown: boolean;
  groups: NBCItemGroups[];
  loadingGroups: boolean;
}

interface GetNBCItems {
  type: NBCActionTypes.RECEIVED_ALL_NBC_ITEMS;
  nbcItems: NBCItem[];
}

interface AddNewNBCItem {
  type: NBCActionTypes.ADD_NEW_NBC_ITEM;
  nbcItem: NBCItem[];
}

interface RequestAllNBCItems {
  type: NBCActionTypes.REQUEST_ALL_NBC_ITEMS;
}

interface UpdateNBCItems {
  type: NBCActionTypes.UPDATE_NBC_ITEMS;
  updateNBCItem: NBCItem[];
}

interface RequestSaveNBCItems {
  type: NBCActionTypes.REQUEST_SAVE_NBC_ITEMS;
}

interface GetProfileNameList {
  type: NBCActionTypes.RECEIVED_PROFILE_NAME_LIST;
  profileNames: NBCProfile[];
}

interface AddNewNBCProfile {
  type: NBCActionTypes.ADD_NEW_NBC_PROFILE;
  profile: NBCProfile[];
}

interface EditNBCProfile {
  type: NBCActionTypes.EDIT_NBC_PROFILE;
  profile: NBCProfile[];
}

interface DeleteNBCProfile {
  type: NBCActionTypes.DELETE_NBC_PROFILE;
  profile: NBCProfile[];
}

interface ReceivedErrorCode {
  type: NBCActionTypes.RECEIVED_NBC_HTTP_RESPONSE_ERROR_CODE;
  statusCode: number;
}

interface ResetHttpResponseError {
  type: NBCActionTypes.RESET_NBC_HTTP_RESPONSE_FETCH_ERROR;
}

interface OverwriteNBCItems {
  type: NBCActionTypes.OVERWRITE_NBC_ITEMS;
  nbcItem: NBCItem[];
}

interface ImportImages {
  type: NBCActionTypes.IMPORT_IMAGES;
}

interface GetAllNBCImages {
  type: NBCActionTypes.GET_ALL_NBC_IMAGES;
  nbcImages: string[];
}

interface ResetNotificationMessage {
  type: NBCActionTypes.RESET_NOTIFICATION_MESSAGE;
}

interface ApplySnapshot {
  type: NBCActionTypes.APPLY_SNAPSHOT;
  response: ResultResponse;
}

interface DeleteNBCItems {
  type: NBCActionTypes.DELETE_NBC_ITEMS;
  nbcItems: NBCItem[];
}

interface GetDrilldownProfileByID {
  type: NBCActionTypes.GET_DRILLDOWN_PROFILE_BY_ID;
  drilldownProfile: DrilldownProfile;
}

interface RequestDrilldownProfile {
  type: NBCActionTypes.REQUEST_DRILLDOWN_PROFILE;
}

interface RequestDrilldownItems {
  type: NBCActionTypes.REQUEST_DRILLDOWN_ITEMS;
  drilldownItems: string[] | null;
}

interface AddNewDrilldown {
  type: NBCActionTypes.ADD_NEW_DRILLDOWN;
  drilldownProfile: DrilldownProfile;
}

interface AddItemToDrilldown {
  type: NBCActionTypes.ADD_ITEM_TO_DRILLDOWN;
  drilldownItems: string[] | null;
}

interface RequestDeleteDrilldown {
  type: NBCActionTypes.REQUEST_DELETE_DRILLDOWN;
  drilldownProfile: DrilldownProfile;
}

interface FetchingDrilldownItems {
  type: NBCActionTypes.FETCHING_DRILLDOWNS;
}

interface GetItemsGroups {
  type: NBCActionTypes.GET_ITEMS_GROUPS;
  groups: NBCItemGroups[];
}

interface LoadingItemsGroups {
  type: NBCActionTypes.LOADING_ITEMS_GROUPS;
}

interface SetNotificationMessage {
  type: NBCActionTypes.SET_NOTIFICATION_MESSAGE;
  messageNotification: string;
}

interface UpdateDrilldown {
  type: NBCActionTypes.UPDATE_DRILLDOWN;
  drilldownProfile: DrilldownProfile;
}

interface requestUpdateDrilldown {
  type: NBCActionTypes.REQUEST_UPDATE_DRILLDOWN;
}

interface UpdateDrilldownPosition {
  type: NBCActionTypes.UPDATE_DRILLDOWN_POSITION;
  drilldownItems: string[] | null;
}


type KnownAction =
  | GetNBCItems
  | AddNewNBCItem
  | RequestAllNBCItems
  | UpdateNBCItems
  | RequestSaveNBCItems
  | GetProfileNameList
  | AddNewNBCProfile
  | EditNBCProfile
  | DeleteNBCProfile
  | ReceivedErrorCode
  | ResetHttpResponseError
  | OverwriteNBCItems
  | ImportImages
  | GetAllNBCImages
  | ResetNotificationMessage
  | ApplySnapshot
  | DeleteNBCItems
  | GetDrilldownProfileByID
  | RequestDrilldownProfile
  | RequestDrilldownItems
  | AddNewDrilldown
  | AddItemToDrilldown
  | FetchingDrilldownItems
  | RequestDeleteDrilldown
  | GetItemsGroups
  | LoadingItemsGroups
  | SetNotificationMessage
  | UpdateDrilldown
  | requestUpdateDrilldown
  | UpdateDrilldownPosition;

const isResponseOk = (response: Response, dispatch: any): boolean => {
  if (response.ok) return true;
  if (response.status === 401) {
    dispatch({
      type: NBCActionTypes.NBC_UNAUTHORIZED_REQUEST,
    });
  } else {
    dispatch({
      type: NBCActionTypes.RECEIVED_NBC_HTTP_RESPONSE_ERROR_CODE,
      statusCode: response.status,
    });
  }
  return false;
};

export const actionCreators = {
  getProfileNameList:
    (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      const response = await fetch(
        `NBC/GetProfiles`,
        getRequestOptions(appState.userSessionReducer.sessionInfo?.Token)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCProfile[];

      console.log(`Dispatching ${NBCActionTypes.RECEIVED_PROFILE_NAME_LIST}`);

      dispatch({
        type: NBCActionTypes.RECEIVED_PROFILE_NAME_LIST,
        profileNames: result,
      });
    },

  fetchNBCItemsByID:
    (profileID: number): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.REQUEST_ALL_NBC_ITEMS,
      });

      const response = await fetch(
        `NBC/GetItems/${profileID}`,
        getRequestOptions(appState.userSessionReducer.sessionInfo?.Token)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCItem[];

      console.log(`Dispatching ${NBCActionTypes.RECEIVED_ALL_NBC_ITEMS}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.RECEIVED_ALL_NBC_ITEMS,
          nbcItems: result,
        });
      }, 1000);
    },

  addNewNBCItem:
    (
      newItems: NBCItem[],
      profileID: number | undefined
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      const response = await fetch(
        `NBC/AddItems/${profileID}`,
        postRequestOptions(
          appState.userSessionReducer.sessionInfo?.Token,
          newItems
        )
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCItem[];

      console.log(`Dispatched NBC to ${NBCActionTypes.ADD_NEW_NBC_ITEM}`);

      dispatch({
        type: NBCActionTypes.ADD_NEW_NBC_ITEM,
        nbcItem: result,
      });
    },

  updateNBCItems:
    (
      updatedItems: NBCItem[],
      profileID: number | undefined
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.REQUEST_ALL_NBC_ITEMS,
      });

      const response = await fetch(
        `NBC/UpdateItems/${profileID}`,
        postRequestOptions(
          appState.userSessionReducer.sessionInfo?.Token,
          updatedItems
        )
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCItem[];

      console.log(`Dispatched ${NBCActionTypes.UPDATE_NBC_ITEMS}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.UPDATE_NBC_ITEMS,
          updateNBCItem: result,
        });
      }, 1000);
    },

  addNewNBCProfile:
    (newProfile: NBCProfile | undefined): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      const response = await fetch(
        `NBC/AddProfile`,
        postRequestOptions(
          appState.userSessionReducer.sessionInfo?.Token,
          newProfile
        )
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCProfile[];

      console.log(`Dispatched ${NBCActionTypes.ADD_NEW_NBC_PROFILE}`);

      dispatch({
        type: NBCActionTypes.RECEIVED_PROFILE_NAME_LIST,
        profileNames: result,
      });
    },

  editNBCProfile:
    (updatedProfile: NBCProfile | undefined): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      const response = await fetch(
        `NBC/EditProfile`,
        postRequestOptions(
          appState.userSessionReducer.sessionInfo?.Token,
          updatedProfile
        )
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCProfile[];

      console.log(`Dispatched ${NBCActionTypes.EDIT_NBC_PROFILE}`);

      dispatch({
        type: NBCActionTypes.RECEIVED_PROFILE_NAME_LIST,
        profileNames: result,
      });
    },

  deleteNBCProfile:
    (profileUuid: NBCProfile | undefined): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      const response = await fetch(
        `NBC/DeleteProfile`,
        postRequestOptions(
          appState.userSessionReducer.sessionInfo?.Token,
          profileUuid
        )
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCProfile[];

      console.log(`Dispatched ${NBCActionTypes.DELETE_NBC_PROFILE}`);

      dispatch({
        type: NBCActionTypes.RECEIVED_PROFILE_NAME_LIST,
        profileNames: result,
      });
    },

  resetFetchError:
    (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      console.log(
        `Dispatching ${NBCActionTypes.RESET_NBC_HTTP_RESPONSE_FETCH_ERROR}`
      );

      dispatch({
        type: NBCActionTypes.RESET_NBC_HTTP_RESPONSE_FETCH_ERROR,
      });
    },

  OverwriteNBCItems:
    (
      newItems: NBCItem[],
      profileID: number | undefined
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.REQUEST_ALL_NBC_ITEMS,
      });

      const response = await fetch(
        `NBC/OverwriteNBCItems/${profileID}`,
        postRequestOptions(
          appState.userSessionReducer.sessionInfo?.Token,
          newItems
        )
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCItem[];

      console.log(`Dispatched NBC to ${NBCActionTypes.OVERWRITE_NBC_ITEMS}`);

      dispatch({
        type: NBCActionTypes.OVERWRITE_NBC_ITEMS,
        nbcItem: result,
      });
    },

  importImages:
    (files: ImageInfo[]): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      console.log(`Dispatched ${NBCActionTypes.IMPORT_IMAGES}`);

      const response = await fetch(
        `NBC/ImportImages`,
        postRequestOptions(
          appState.userSessionReducer.sessionInfo?.Token,
          files
        )
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as string[];

      dispatch({
        type: NBCActionTypes.IMPORT_IMAGES,
      });

      dispatch({
        type: NBCActionTypes.GET_ALL_NBC_IMAGES,
        nbcImages: result,
      });
    },

  getAllNBCImages:
    (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      const response = await fetch(
        `NBC/GetALLNBCImages`,
        getRequestOptions(appState.userSessionReducer.sessionInfo?.Token)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as string[];

      dispatch({
        type: NBCActionTypes.GET_ALL_NBC_IMAGES,
        nbcImages: result,
      });
    },

  resetNotificationMessage:
    (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      console.log(`Dispatching ${NBCActionTypes.RESET_NOTIFICATION_MESSAGE}`);

      dispatch({
        type: NBCActionTypes.RESET_NOTIFICATION_MESSAGE,
      });
    },

  applySnapshot:
    (
      profileInfo: NBCProfile | undefined,
      scheduledDateTime: String | undefined,
      applyNow: boolean,
      snapshotType: string
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      console.log(`Dispatched ${NBCActionTypes.APPLY_SNAPSHOT}`);

      let response;

      if (snapshotType === NBC_ITEM) {
        response = await fetch(
          `NBC/ApplySnapshot/${scheduledDateTime}/${applyNow}`,
          postRequestOptions(
            appState.userSessionReducer.sessionInfo?.Token,
            profileInfo
          )
        ).catch(error => {
          console.error(error);
          return Promise.reject(error);
        });
      } else if (snapshotType === NBC_DRILLDOWN) {
        response = await fetch(
          `NBC/ApplyDrilldownSnapshot/${scheduledDateTime}/${applyNow}`,
          postRequestOptions(
            appState.userSessionReducer.sessionInfo?.Token,
            profileInfo
          )
        ).catch(error => {
          console.error(error);
          return Promise.reject(error);
        });
      }

      if (response) {
        if (!isResponseOk(response, dispatch)) return;

        const result = (await response.json()) as ResultResponse;

        dispatch({
          type: NBCActionTypes.APPLY_SNAPSHOT,
          response: result,
        });
      }
    },

  deleteNBCItems:
    (
      itemKeys: string[],
      profileID: number | undefined
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.REQUEST_ALL_NBC_ITEMS,
      });

      const response = await fetch(
        `NBC/DeleteItems/${profileID}`,
        postRequestOptions(
          appState.userSessionReducer.sessionInfo?.Token,
          itemKeys
        )
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCItem[];

      console.log(`Dispatched ${NBCActionTypes.DELETE_NBC_ITEMS}`);

      dispatch({
        type: NBCActionTypes.DELETE_NBC_ITEMS,
        nbcItems: result,
      });
    },

  getDrilldownProfileByID:
    (profileID: number | undefined): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.REQUEST_DRILLDOWN_PROFILE,
      });

      const response = await fetch(
        `NBC/GetDrilldownProfileByID/${profileID}`,
        getRequestOptions(appState.userSessionReducer.sessionInfo?.Token)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as DrilldownProfile;

      console.log(`Dispatched ${NBCActionTypes.REQUEST_DELETE_DRILLDOWN}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.GET_DRILLDOWN_PROFILE_BY_ID,
          drilldownProfile: result,
        });
      }, 1000);
    },

  deleteDrilldown:
    (
      profileID: number | undefined,
      drilldownID: string
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.FETCHING_DRILLDOWNS,
      });

      const response = await fetch(
        `NBC/DeleteDrilldown/${profileID}/${drilldownID}`,
        getRequestOptions(appState.userSessionReducer.sessionInfo?.Token)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as DrilldownProfile;

      console.log(`Dispatched ${NBCActionTypes.REQUEST_DELETE_DRILLDOWN}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.REQUEST_DELETE_DRILLDOWN,
          drilldownProfile: result,
        });
      }, 1000);
    },

  deleteDrilldownItem:
    (
      profileID: number | undefined,
      drilldownID: string,
      itemToDelete: string
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      const response = await fetch(
        `NBC/DeleteDrilldownItem/${profileID}/${drilldownID}/${itemToDelete}`,
        getRequestOptions(appState.userSessionReducer.sessionInfo?.Token)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      dispatch({
        type: NBCActionTypes.FETCHING_DRILLDOWNS,
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as string[] | null;

      console.log(`Dispatched ${NBCActionTypes.REQUEST_DELETE_DRILLDOWN_ITEM}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.REQUEST_DRILLDOWN_ITEMS,
          drilldownItems: result,
        });
      }, 1000);
    },

  requestDrilldownItemsByID:
    (
      profileID: number | undefined,
      drilldownID: string
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.FETCHING_DRILLDOWNS,
      });

      const response = await fetch(
        `NBC/GetDrilldownItemsByDrilldownID/${profileID}/${drilldownID}`,
        getRequestOptions(appState.userSessionReducer.sessionInfo?.Token)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as string[] | null;

      console.log(`Dispatched ${NBCActionTypes.REQUEST_DRILLDOWN_ITEMS}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.REQUEST_DRILLDOWN_ITEMS,
          drilldownItems: result,
        });
      }, 1000);
    },

  addNewDrilldown:
    (
      profileID: number | undefined,
      treeviewDataItem: TreeViewDataItem
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.FETCHING_DRILLDOWNS,
      });

      const response = await fetch(
        `NBC/AddNewDrilldown/${profileID}`,
        postRequestOptions(
          appState.userSessionReducer.sessionInfo?.Token,
          treeviewDataItem
        )
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as DrilldownProfile;

      console.log(`Dispatched ${NBCActionTypes.ADD_NEW_DRILLDOWN}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.ADD_NEW_DRILLDOWN,
          drilldownProfile: result,
        });
      }, 1000);
    },

  addItemToDrilldown:
    (
      profileID: number | undefined,
      itemsToAdd: string[],
      drilldownID: string
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.FETCHING_DRILLDOWNS,
      });

      const response = await fetch(
        `NBC/AddItemsToDrilldown/${profileID}/${drilldownID}`,
        postRequestOptions(
          appState.userSessionReducer.sessionInfo?.Token,
          itemsToAdd
        )
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as string[] | null;

      console.log(`Dispatched ${NBCActionTypes.ADD_ITEM_TO_DRILLDOWN}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.ADD_ITEM_TO_DRILLDOWN,
          drilldownItems: result,
        });
      }, 1000);
    },

  getItemsGroups:
    (profileID: number | undefined): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.LOADING_ITEMS_GROUPS,
      });

      const response = await fetch(
        `NBC/GetItemGroups/${profileID}`,
        getRequestOptions(appState.userSessionReducer.sessionInfo?.Token)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCItemGroups[];

      console.log(`Dispatching ${NBCActionTypes.GET_ITEMS_GROUPS}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.GET_ITEMS_GROUPS,
          groups: result,
        });
      }, 1000);
    },

  updateDrilldown:
    (
      item: TreeViewDataItem,
      profileID: number | undefined,
      prevDrilldownName: string
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.REQUEST_UPDATE_DRILLDOWN,
      });

      const response = await fetch(
        `NBC/UpdateDrilldown/${profileID}/${prevDrilldownName}`,
        postRequestOptions(appState.userSessionReducer.sessionInfo?.Token, item)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as DrilldownProfile;

      console.log(`Dispatched ${NBCActionTypes.UPDATE_DRILLDOWN}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.UPDATE_DRILLDOWN,
          drilldownProfile: result,
        });
      }, 1000);
    },

  editItemsGroups:
    (
      profileID: number | undefined,
      groupUuid: string | undefined,
      updatedGroupName: string | undefined
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.LOADING_ITEMS_GROUPS,
      });

      const response = await fetch(
        `NBC/EditItemGroups/${profileID}/${groupUuid}/${updatedGroupName}`,
        getRequestOptions(appState.userSessionReducer.sessionInfo?.Token)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCItemGroups[];

      console.log(`Dispatching ${NBCActionTypes.GET_ITEMS_GROUPS}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.GET_ITEMS_GROUPS,
          groups: result,
        });
      }, 1000);
    },

  deleteItemsGroups:
    (
      profileID: number | undefined,
      groupUuid: string | undefined
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.LOADING_ITEMS_GROUPS,
      });

      const response = await fetch(
        `NBC/DeleteItemGroups/${profileID}/${groupUuid}`,
        getRequestOptions(appState.userSessionReducer.sessionInfo?.Token)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCItemGroups[];

      console.log(`Dispatching ${NBCActionTypes.GET_ITEMS_GROUPS}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.GET_ITEMS_GROUPS,
          groups: result,
        });
      }, 1000);
    },

  addItemsGroups:
    (
      profileID: number | undefined,
      groupName: string
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      dispatch({
        type: NBCActionTypes.LOADING_ITEMS_GROUPS,
      });

      const response = await fetch(
        `NBC/AddItemGroups/${profileID}/${groupName}`,
        getRequestOptions(appState.userSessionReducer.sessionInfo?.Token)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as NBCItemGroups[];

      console.log(`Dispatching ${NBCActionTypes.GET_ITEMS_GROUPS}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.GET_ITEMS_GROUPS,
          groups: result,
        });
      }, 1000);
    },

    updateDrilldownItemPositionByDrilldownID:
    (
      profileID: number | undefined,
      drilldownID: string | null,
      items:string[]
    ): AppThunkAction<KnownAction> =>
    async (dispatch, getState) => {
      const appState = getState();
      if (!appState) return;

      const response = await fetch(
        `NBC/UpdateDrilldownItemPositionByDrilldownID/${profileID}/${drilldownID}`,
        postRequestOptions(appState.userSessionReducer.sessionInfo?.Token, items)
      ).catch(error => {
        console.error(error);
        return Promise.reject(error);
      });

      if (!isResponseOk(response, dispatch)) return;

      const result = (await response.json()) as string[] | null;

      console.log(`Dispatched ${NBCActionTypes.UPDATE_DRILLDOWN_POSITION}`);

      setTimeout(() => {
        dispatch({
          type: NBCActionTypes.UPDATE_DRILLDOWN_POSITION,
          drilldownItems: result,
        });
      }, 1000);
    },
};

export const unloadedState: NBCState = {
  nbcItems: [],
  fetchingNbcItems: false,
  updateNBCItem: [],
  profileNames: [],
  fetchError: { StatusCode: 0, Message: '' },
  nbcImages: [],
  messageNotification: '',
  response: { IsOk: false, Message: '' },
  drilldownProfile: { ProfileID: undefined, TreeViewDataItem: [] },
  drilldownItems: [],
  fetchingDrilldown: false,
  groups: [],
  loadingGroups: false,
};

export const reducer: Reducer<NBCState> = (
  state: NBCState | undefined,
  incomingAction: Action
): NBCState => {
  if (state === undefined) {
    return unloadedState;
  }

  const action = incomingAction as KnownAction;
  switch (action.type) {
    case NBCActionTypes.RECEIVED_ALL_NBC_ITEMS:
      return {
        ...state,
        nbcItems: action.nbcItems,
        fetchingNbcItems: false,
      };

    case NBCActionTypes.ADD_NEW_NBC_ITEM:
      const newItems = [...state.nbcItems];
      action.nbcItem.map(item => newItems.push(item));
      return {
        ...state,
        nbcItems: newItems,
        messageNotification: 'ADDED_NBC_ITEM_MESSAGE',
      };

    case NBCActionTypes.REQUEST_ALL_NBC_ITEMS:
      return {
        ...state,
        fetchingNbcItems: true,
      };

    case NBCActionTypes.UPDATE_NBC_ITEMS:
      const mergedUpdatedItems = Array.from(
        new Map(
          [...state.nbcItems, ...action.updateNBCItem].map(item => [
            item.Key,
            item,
          ])
        ).values()
      );
      return {
        ...state,
        nbcItems: mergedUpdatedItems,
        fetchingNbcItems: false,
        messageNotification: 'UPDATE_NBC_ITEM_MESSAGE',
      };

    case NBCActionTypes.REQUEST_SAVE_NBC_ITEMS:
      return {
        ...state,
        fetchingNbcItems: true,
      };

    case NBCActionTypes.RECEIVED_PROFILE_NAME_LIST:
      return {
        ...state,
        profileNames: action.profileNames,
      };

    case NBCActionTypes.ADD_NEW_NBC_PROFILE:
      return {
        ...state,
        profileNames: action.profile,
      };
    case NBCActionTypes.EDIT_NBC_PROFILE:
      return {
        ...state,
        profileNames: action.profile,
      };
    case NBCActionTypes.DELETE_NBC_PROFILE:
      return {
        ...state,
        profileNames: action.profile,
      };
    case NBCActionTypes.RECEIVED_NBC_HTTP_RESPONSE_ERROR_CODE:
      let fetchErrorData = {
        StatusCode: action.statusCode,
        Message: 'FETCH_ERROR_MESSAGE_NBC',
      };
      return {
        ...state,
        fetchError: fetchErrorData,
        fetchingNbcItems: false,
      };
    case NBCActionTypes.RESET_NBC_HTTP_RESPONSE_FETCH_ERROR:
      let resetData = { StatusCode: 0, Message: '' };
      return {
        ...state,
        fetchError: resetData,
      };
    case NBCActionTypes.OVERWRITE_NBC_ITEMS:
      return {
        ...state,
        nbcItems: action.nbcItem,
        fetchingNbcItems: false,
        messageNotification: 'IMPORT_MESSAGE',
      };
    case NBCActionTypes.GET_ALL_NBC_IMAGES:
      return {
        ...state,
        nbcImages: action.nbcImages,
      };
    case NBCActionTypes.IMPORT_IMAGES:
      return {
        ...state,
        messageNotification: 'IMPORT_MESSAGE',
      };
    case NBCActionTypes.RESET_NOTIFICATION_MESSAGE:
      return {
        ...state,
        messageNotification: '',
        response: { IsOk: false, Message: '' },
      };

    case NBCActionTypes.APPLY_SNAPSHOT:
      return {
        ...state,
        response: action.response,
      };

    case NBCActionTypes.DELETE_NBC_ITEMS:
      return {
        ...state,
        nbcItems: action.nbcItems,
        fetchingNbcItems: false,
        messageNotification:
          'NOTIFICATION_SUCCESSFULLY_DELETED_CONFIRMATION_MESSAGE',
      };

    case NBCActionTypes.REQUEST_DRILLDOWN_PROFILE:
      return {
        ...state,
        fetchingNbcItems: true,
      };

    case NBCActionTypes.GET_DRILLDOWN_PROFILE_BY_ID:
      return {
        ...state,
        drilldownProfile: action.drilldownProfile,
        fetchingNbcItems: false,
      };

    case NBCActionTypes.REQUEST_DRILLDOWN_ITEMS:
      return {
        ...state,
        drilldownItems: action.drilldownItems,
        fetchingDrilldown: false,
      };

    case NBCActionTypes.ADD_NEW_DRILLDOWN:
      return {
        ...state,
        drilldownProfile: action.drilldownProfile,
        fetchingDrilldown: false,
      };

    case NBCActionTypes.ADD_ITEM_TO_DRILLDOWN:
      return {
        ...state,
        drilldownItems: action.drilldownItems,
        fetchingDrilldown: false,
      };

    case NBCActionTypes.FETCHING_DRILLDOWNS:
      return {
        ...state,
        fetchingDrilldown: true,
      };

    case NBCActionTypes.REQUEST_DELETE_DRILLDOWN:
      return {
        ...state,
        drilldownProfile: action.drilldownProfile,
        fetchingDrilldown: false,
      };

    case NBCActionTypes.LOADING_ITEMS_GROUPS:
      return {
        ...state,
        loadingGroups: true,
      };

    case NBCActionTypes.GET_ITEMS_GROUPS:
      return {
        ...state,
        groups: action.groups,
        loadingGroups: false,
      };

    case NBCActionTypes.SET_NOTIFICATION_MESSAGE:
      return {
        ...state,
        messageNotification: action.messageNotification,
      };
    case NBCActionTypes.UPDATE_DRILLDOWN:
      return {
        ...state,
        drilldownProfile: action.drilldownProfile,
        fetchingNbcItems: false,
      };
    case NBCActionTypes.REQUEST_UPDATE_DRILLDOWN:
      return {
        ...state,
        fetchingNbcItems: true,
      };
      case NBCActionTypes.UPDATE_DRILLDOWN_POSITION:
      return {
        ...state,
        drilldownItems: action.drilldownItems, 
      };

    default:
      break;
  }
  return state;
};
